import React from 'react'

import { useMerchantData } from '@contexts/admin/MerchantDataContext'
import ListPageHeader from '@shared/ListPageHeader'
import OutOfStockProductsList from '@shared/out_of_stock_products/OutOfStockProductsList'

import { brandService } from '@services/admin/brandService'
import { outOfStockProductService } from '@services/admin/outOfStockProductService'

export default function AdminOutOfStockProductsList() {
  const { salesChannels } = useMerchantData()

  return (
    <div>
      <ListPageHeader
        basePath="/admin"
        items={['orders', 'orders.out_of_stock']}
      />
      <OutOfStockProductsList
        role="admin"
        service={outOfStockProductService}
        brandService={brandService}
        salesChannels={salesChannels}
      />
    </div>
  )
}
